import { Component, OnInit } from '@angular/core';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { ExternalRequest } from 'src/app/shared/models/channel-communicator/external-request.model';
import {
  OptionCheckBoxModel,
  OptionRadioModel,
} from 'src/app/shared/models/common.model';
import { LogDeviceModel } from 'src/app/shared/models/log-device.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { PayDayProductModel } from '../../../shared/models/abre-cuentas.model';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { IFirmlyApproved } from 'src/app/shared/interfaces/firmly-approved';
import { navCode } from 'src/app/shared/constants/channel.constants';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_TC,
  PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA,
} from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

/**
 * Update type product and date to pay it
 *
 * @export
 * @class PayDayFormTcComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-pay-day-form-tc',
  templateUrl: './pay-day-form-tc.component.html',
  styleUrls: ['./pay-day-form-tc.component.scss'],
})
export class PayDayFormTcComponent implements OnInit {
  listPayDay: OptionRadioModel[];
  listProducts: OptionCheckBoxModel[];

  selectedPayDay: OptionRadioModel;
  selectedProduct: OptionCheckBoxModel;

  ipBiocatch: string;
  enableButtonNext = false;
  devicePrint: LogDeviceModel;
  getDeviceInfoRq: ExternalRequest;
  isGrayZone = false;

  payDayProductModel: PayDayProductModel = {
    selectedPayDay: {},
    selectedProduct: {},
  } as PayDayProductModel;

  selects = ['selectedPayDay', 'selectedProduct'];
  limits: any;
  clientCards = 0;
  aprovedAmount: number;
  multipleProduct: boolean;
  productsType = {
    ORD: 'LD',
    TCR: 'TC',
  };
  isClient: any;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private parameterService: ParametersService,
    private bitacoraService: BitacoraService,
    private channel: ChannelCommunicatorService,
    private firmlyApprovedService: FirmlyApprovedService,
    private taggingService: TaggingService,
    private daliService: DaliService,
  ) {
    this.devicePrint = new LogDeviceModel();
    this.headerService.show(true, true, true);
  }

  /**
   * Initialize and update lists of options and variables selected
   *
   * @memberof PayDayFormTcComponent
   */
  ngOnInit() {
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendPayDayPageLoad();
    }
    this.limits = this.parameterService.getSetting(
      OpEnum.MULTIPLE_PRODUCT_TC_LIMITS,
    );
    this.setPayDayProductModel();
    // if (this.abreCuentasService.getproductSelected().product_type !== BUSINESS_CONST.PRODUCT_TYPE_TC) {
    //   return;
    // }
    const isClient = this.abreCuentasService.getProspectResponse()
      ? this.abreCuentasService.getProspectResponse().client
      : false;
    if (
      this.firmlyApprovedService.isEmpty() &&
      this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme'
    ) {
      this.getPcoModel();
    } else {
      this.getModelisFirmly();
    }

    // if (isClient) {
    //   this.getClientInfo();
    // }
  }

  /**
   * Setea los valores de fecha y franquia/s que se tienen en el servicio de abrecuentas dentro del form
   */
  async setPayDayProductModel() {
    this.payDayProductModel =
      await this.abreCuentasService.getPayDayProductSelected();
    if (Object.entries(this.payDayProductModel).length === 0) {
      this.payDayProductModel = {
        selectedPayDay: {},
        selectedProduct: {},
      };
    }
    this.getListPayDay();
    this.getListProducts();
    this.validateCheckboxes();
    this.payDayProductValidation();
  }

  /**
   * Este metodo obtiene la información relacionada a los productos del cliente
   */
  async getClientInfo() {
    const data = this.abreCuentasService.getListClientProduct();
    if (!data || data.length < 1) {
      return;
    }
    data.forEach((record: any) => {
      if (record.product_type === 'TCR') {
        this.clientCards++;
      }
    });
  }

  /**
   * Obtiene el modelo de PCO, los valores limites y establece criterios de selección de multiples franquicias
   */
  getPcoModel() {
    let pcoModel: any = this.abreCuentasService.getPcoModel();
    // if(pcoModel.length > 0){
    //   pcoModel = pcoModel.find(product => product.granted_product.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC)
    // }
    this.isGrayZone =
      pcoModel.solicitation_status.status_code === 'PCO03' ? true : false;
    if (
      this.abreCuentasService.getproductSelected().product_type ===
      BUSINESS_CONST.PRODUCT_TYPE_TC
    ) {
      this.aprovedAmount = pcoModel.granted_product.limit_amount.amount;
      this.multipleProduct =
        this.aprovedAmount >= this.limits.minimumAmount ? true : false;
    }
    if (
      this.abreCuentasService.getproductSelected().product_type ===
      BUSINESS_CONST.MULTI
    ) {
      pcoModel = pcoModel.granted_product_multi.find(
        product => product.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC,
      );
      this.aprovedAmount = pcoModel.limit_amount.amount;
      this.multipleProduct =
        this.aprovedAmount >= this.limits.minimumAmount ? true : false;
    }
    this.multipleProduct =
      this.channel.getChannelId() === '163' ? false : this.multipleProduct;
  }

  /**
   * Obtiene el modelo de PCO, los valores limites y establece criterios de selección de multiples franquicias
   */
  getModelisFirmly() {
    // return ;
    let ModelisFirmly = this.firmlyApprovedService.getProduct_FirmlyApproved(BUSINESS_CONST.PRODUCT_CODE_TCR) as IFirmlyApproved;
    this.isGrayZone = false;

    this.aprovedAmount = parseInt(ModelisFirmly.amount, 10);
    this.multipleProduct =
      this.aprovedAmount >= this.limits.minimumAmount ? true : false;
    /* this.multipleProduct =
      this.channel.getChannelId() === '163' ? false : this.multipleProduct; */
  }

  /**
   * Obtiene la lista de los días de pago para el radio options
   */
  getListPayDay() {
    this.listPayDay = this.parameterService
      .getSetting(OpEnum.PAY_DATE_TC_LIST)
      .map(data => this.mapList(data, 0));
  }

  /**
   * Obtiene la lista de productos para el radio options
   */
  getListProducts() {
    if (!this.abreCuentasService.getAllyCode()) {
      return (this.listProducts = this.parameterService
        .getSetting(OpEnum.PRODUCTS_TC_LIST)
        .map(data => this.mapList(data, 1)));
    }
    const listProducts = this.parameterService.getSetting(
      OpEnum.PRODUCTS_TC_LIST,
    );
    let itemFranchise = this.abreCuentasService.getRateAlly().brands;
    if (itemFranchise[0] === 'mastercard') {
      itemFranchise[0] = 'card';
    } else {
      itemFranchise = this.abreCuentasService.getRateAlly().brands;
    }
    itemFranchise.forEach((element, index) => {
      this.listProducts = listProducts.filter(word =>
        word.label.toLowerCase().includes(element[index].toLowerCase()),
      );
    });
    this.listProducts = this.listProducts.map(data => this.mapList(data, 1));
  }

  /**
   * mapea los listados para establecer el valor del radio y el/los checked boxes
   * @param data
   * @param index
   */
  mapList(data: any, index: number) {
    if (
      !this.payDayProductModel ||
      !this.payDayProductModel[this.selects[index]]
    ) {
      return;
    }
    if (this.payDayProductModel[this.selects[index]].length > 0) {
      const product = this.payDayProductModel[this.selects[index]].find(
        (p: any) => p.elementId === data.elementId,
      );
      return product ? product : { ...data, checked: false };
    }
    return this.payDayProductModel[this.selects[index]].elementId ===
      data.elementId
      ? this.payDayProductModel[this.selects[index]]
      : { ...data, checked: false };
  }

  /**
   * asigna el valor del radio option seleccionado al objeto payDayProductModel de persistencia en el flujo
   * llama a la función encargada de actualizar el servicio que controla la infromación de los radio
   * llama a la funcion encargada de validar el valor de los radio para habilitar el boton next
   * @param event
   * @param index
   */
  onRadioChange(event, index) {
    event.value.checked = true;
    this.payDayProductModel[this.selects[index]] =
      index === 0 ? event.value : [event.value];
    this.updatePayDayProductInService();
    this.payDayProductValidation();
  }

  /**
   * Valida el objeto payDatProductModel, para habilitar el boton next
   */
  payDayProductValidation() {
    this.enableButtonNext = !!(
      this.payDayProductModel[this.selects[0]] &&
      Object.entries(this.payDayProductModel[this.selects[0]]).length !== 0 &&
      ((this.payDayProductModel[this.selects[1]] &&
        Object.entries(this.payDayProductModel[this.selects[1]]).length !==
        0) ||
        this.payDayProductModel[this.selects[1]].length > 0)
    );
  }

  /**
   * update selected options to global model and redireccct next view
   * update selected options to global model and redireccct next view
   * @memberof PayDayFormTcComponent
   */
  next() {
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    let bitacoraEvent = 'product_datapayment';
    console.warn('Pay-day-form-tc >>>> Nect >>>> payDayProductModel: ', this.payDayProductModel);
    if (this.payDayProductModel[this.selects[1]].length === 1) {
      this.payDayProductModel[this.selects[1]] =
        this.payDayProductModel[this.selects[1]][0];
      this.abreCuentasService.setVirtualCardFranchise({ selectedFranchise: this.payDayProductModel[this.selects[1]] });
    } else if (this.payDayProductModel[this.selects[1]].length > 1) {
      let strProduct = '';
      this.payDayProductModel[this.selects[1]].forEach(product => {
        strProduct += `_${product.label.replace(' ', '_')}`;
      });
      bitacoraEvent +=
        strProduct +
        `_${this.payDayProductModel[this.selects[0]].label.substring(4, 6)}`;
      this.saveAndGo('201', bitacoraEvent);
      return;
    }
    bitacoraEvent += `_${this.payDayProductModel[this.selects[1]].label.replace(
      ' ',
      '_',
    )}_${this.payDayProductModel[this.selects[0]].label.substring(4, 6)}`;
    this.saveAndGo('200', bitacoraEvent);
  }

  saveAndGo(status, bitacoraEvent) {
    console.log('Next >>> code: ', status);
    this.updatePayDayProductInService();
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    if (
      !this.firmlyApprovedService.isEmpty() &&
      this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
    ) {
      this.changeDetailTC_FirmlyApproved();
    }
    if (this.abreCuentasService.viewOptionMultiProduct) {
      this.regularNavigationMulti();
    } else {
      this.navigationService.nextStep(status);
    }
  }

  regularNavigationMulti() {
    this.navigationService.nextStep(
      this.navigationService.nextMulti(
        this.abreCuentasService.getProductsSelects(),
      ),
    );
  }

  /**
   * Función que llena los datos del detalle de la TC,
   * seleccionado por el usuario.
   * Únicamente para un Aprobado En Firme
   */
  private changeDetailTC_FirmlyApproved() {
    const productSelected = this.payDayProductModel.selectedProduct;
    console.log('changeDetailTC_FirmlyApproved: ', productSelected);
    const productType = this.abreCuentasService.getproductSelected().product_type;
    console.log('PRODUCT_TYPE', productType);
    const isMultiProdType = productType === BUSINESS_CONST.MULTI;
    this.firmlyApprovedService.delete_DetailProductMulti(BUSINESS_CONST.PRODUCT_TYPE_TC);
    this.firmlyApprovedService.setDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC, productSelected.length);
    if (isMultiProdType) {
      this.firmlyApprovedService.setMultiproducto_Signal(true);
      this.abreCuentasService.setMultiView(true);
    } else {
      this.firmlyApprovedService.setMultiproducto_Signal(false);
      this.abreCuentasService.setMultiView(false);
    }
    if (productSelected.length > 1) {
      this.firmlyApprovedService.setMultiproducto_Signal(true);
      this.abreCuentasService.setMultiView(true);
      productSelected.forEach(product_tc => {
        let brand = this.firmlyApprovedService.selectedBrand(product_tc.elementId);
        console.log('brand: ', brand.toString());
        this.firmlyApprovedService.getDetailProductsMulti(
          BUSINESS_CONST.PRODUCT_TYPE_TC,
        ).find(card => card.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && card.brand === '').brand = brand;
      });
      console.log('GRANTED_PRODUCT_DUALITY', this.abreCuentasService.getPcoModel().granted_product_multi);
    } else {
      let brand = this.firmlyApprovedService.selectedBrand(productSelected.elementId);
      this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)[0].brand = brand;
    }
    if (isMultiProdType) {
      const freeInvestment = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_FREE)[0];
      const creditCard = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)[0];
      const revolvingCredit = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)[0];
      const productsFirmlyApproved: any[] = [];
      if (freeInvestment) {
        productsFirmlyApproved.push(freeInvestment);
      }
      productsFirmlyApproved.push(creditCard);
      if (revolvingCredit) {
        productsFirmlyApproved.push(revolvingCredit);
      }
      this.abreCuentasService.getPcoModel().granted_product_multi = productsFirmlyApproved;
    } else {
      this.abreCuentasService.getPcoModel().granted_product = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)[0];
    }
    console.log(
      'getDetailProductsMulti >>> TC: ',
      this.firmlyApprovedService.getDetailProductsMulti(),
    );
  }

  /**
   * Actualiza en el servicio los valores de payDayProductModel
   */
  updatePayDayProductInService() {
    if (
      this.payDayProductModel &&
      (this.payDayProductModel[this.selects[0]] ||
        this.payDayProductModel[this.selects[1]])
    ) {
      this.abreCuentasService.setPayDayProductSelected(this.payDayProductModel);
    }
  }

  /**
   * asigna el valor del checkbox seleccionado al objeto payDayProductModel de persistencia en el flujo
   * llama a la función encargada de actualizar el servicio que controla la información de los radio
   * llama a la funcion encargada de validar el valor de los radio para habilitar el boton next
   * @param event
   * @param product
   * @param index
   */
  onCheckBoxChange(event: any, product: any, index: number) {
    product.checked = event.checked;
    this.changeCardTypes(product, index);
    this.validateCheckboxes();
    this.updatePayDayProductInService();
    this.payDayProductValidation();
  }

  /**
   * asigna el valor del checkbox seleccionado al objeto payDayProductModel de persistencia en el flujo
   * @param product
   * @param index
   */
  changeCardTypes(product: any, index: number) {
    if (
      !this.payDayProductModel[this.selects[index]] ||
      Object.entries(this.payDayProductModel[this.selects[index]]).length === 0
    ) {
      this.payDayProductModel[this.selects[index]] = [product];
      return;
    }
    if (this.payDayProductModel[this.selects[index]].elementId) {
      this.payDayProductModel[this.selects[index]] = [
        this.payDayProductModel[this.selects[index]],
      ];
    }
    if (!product.checked) {
      this.payDayProductModel[this.selects[index]].splice(
        this.payDayProductModel[this.selects[index]].findIndex(
          (pr: any) => pr.elementId === product.elementId,
        ),
        1,
      );
      return;
    }
    this.payDayProductModel[this.selects[index]].push(product);
  }

  /**
   * valida los checkbos que estan habilitados
   */
  validateCheckboxes() {
    let avaliableAmount = this.aprovedAmount;
    if (!this.payDayProductModel[this.selects[1]]) {
      return;
    }
    if (this.payDayProductModel[this.selects[1]].elementId) {
      avaliableAmount = this.updateAvaliableAmount(
        avaliableAmount,
        this.payDayProductModel[this.selects[1]].label,
      );
    }
    if (this.payDayProductModel[this.selects[1]].length >= 0) {
      this.payDayProductModel[this.selects[1]].forEach((pr: any) => {
        avaliableAmount = this.updateAvaliableAmount(avaliableAmount, pr.label);
      });
    }
    if (this.clientCards === 0 || this.clientCards === 1) {
      this.assignByAmount(avaliableAmount);
    } else if (this.clientCards === 2) {
      if (this.payDayProductModel[this.selects[1]].length <= 1) {
        this.assignByAmount(avaliableAmount);
      } else {
        console.log('listProducts----------->', this.listProducts);

        this.listProducts.forEach(pr => {
          console.log('---pr---', pr);

          if (!pr.checked) {
            pr.disabled = true;
          }
        });
      }
    }
  }

  /**
   * Actualiza el monto que se tiene disponible
   * @param avaliableAmount
   * @param label
   */
  updateAvaliableAmount(avaliableAmount, label) {
    switch (label) {
      case 'Mastercard':
        avaliableAmount -= 1000000;
        break;
      case 'Visa':
        avaliableAmount -= 1000000;
        break;
      case 'Visa LifeMiles':
        avaliableAmount -= 2000000;
        break;
    }
    return avaliableAmount;
  }

  /**
   * habilita o desabilita los checkbox según el monto disponible
   * @param avaliableAmount
   */
  assignByAmount(avaliableAmount: number) {
    console.log('listProducts', this.listProducts);
    console.log('avaliableAmount', avaliableAmount);

    if (avaliableAmount >= 2000000) {
      console.log('acaaaaa');

      this.listProducts.map(pr => {
        console.log('´---pr---', pr);

        pr.disabled = false;
      });
    } else if (avaliableAmount >= 1000000 && avaliableAmount < 2000000) {
      console.log('else  if');

      this.listProducts[0].disabled = false;
      console.log('else  if 2');

      this.listProducts[1].disabled = false;
      console.log('else  if 3');

      this.listProducts[2].disabled = true;
      console.log('else  if 4');
    } else {
      this.listProducts.forEach(pr => {
        console.log('for each', pr);

        if (!pr.checked) {
          pr.disabled = true;
        }
      });
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendPayDayPageLoad(): void {
    const isApp = this.channel.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv8pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv8pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv8pageFamily.path,
        value: PAGEVIEW_FA.pv8pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv8subFamily.path,
        value: PAGEVIEW_FA.pv8subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv8pageAction.path,
        value: PAGEVIEW_FA.pv8pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv8pageid.path,
        value: PayDayFormTcComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv8transactionName.path,
        value: PAGEVIEW_FA.pv8transactionName.value,
      },
      {
        path: PAGEVIEW_FA.pv8transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv8transactionTransactionStep.value,
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */

  sendBackButtonEvent(): void {
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_TC.pv8E1setData.pv8E1transactionTransactionStep.path,
        value: EVENT_FA_TC.pv8E1setData.pv8E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv8E1setData.pv8E1transactionName.path,
        value: EVENT_FA_TC.pv8E1setData.pv8E1transactionName.value, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.bottom,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv8E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_TC.pv8E2setData.pv8E2transactionTransactionStep.path,
        value: EVENT_FA_TC.pv8E2setData.pv8E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv8E2setData.pv8E2transactionName.path,
        value: EVENT_FA_TC.pv8E2setData.pv8E2transactionName.value, // cambiar valor segun sea LD o TC
      },
      {
        path: EVENT_FA_TC.pv8E2setData.pv8E2transactionCardnetwork.path,
        value: this.getCardFranchises(),
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.bottom,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv8E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  /* -------------- Taggeo - Utils -------------- */
  getCardFranchises(): string {
    const franchisSelected: string[] = [];
    this.listProducts.forEach(product => {
      if (product.checked) {
        franchisSelected.push(product.label);
      }
    });
    return franchisSelected.toString().replace(/\s/g, '');
  }
}
